import { Box, BoxProps } from '@chakra-ui/react'
import DOMPurify from 'dompurify'
import './WysiwygContent.css'

interface IWysiwygContentProps extends BoxProps {
  content: string
}

/**
 * Componente para renderizar conteúdo HTML de editores WYSIWYG (ReactQuill, TinyMCE, etc)
 * com formatação apropriada isolada do resto da aplicação.
 *
 * O HTML é sanitizado com DOMPurify antes de ser injetado, evitando XSS armazenado
 * a partir de conteúdo vindo da API (crítico porque o dashboard guarda token no
 * localStorage). Este é o único sink de HTML de WYSIWYG — não crie novos.
 */
export default function WysiwygContent({ content, ...boxProps }: IWysiwygContentProps) {
  const sanitized = DOMPurify.sanitize(content ?? '')

  return <Box className="wysiwyg-content" dangerouslySetInnerHTML={{ __html: sanitized }} {...boxProps} />
}
